import fiscalApi from "./fiscalApi";

const fiscalService = {
	async ping() {
		return await fiscalApi.get("/index.php");
	},

	async controlReport() {
		return await fiscalApi.get("/index.php?q=control-report");
	},

	async closeDayReport() {
		return await fiscalApi.get("/index.php?q=close-day-report");
	},

	async depositWithdrawMoney(amount) {
		return await fiscalApi.post("/index.php?q=deposit-withdraw-money", {
			amount: Number(amount),
		});
	},

	async periodShortReport(start, end) {
		const format = (d) => {
			const date = d instanceof Date ? d : new Date(d);
			return date.toISOString().slice(0, 10); // yyyy-MM-dd
		};
		return await fiscalApi.post("/index.php?q=period-short-report", {
			from: format(start),
			to: format(end),
		});
	},

	async fiscalReceipt(items, payments) {
		return await fiscalApi.post("/index.php?q=fiscal", {
			items,
			payments,
		});
	},
};

export default fiscalService;

// fiscalApi has no interceptor, so callers turn failures into a message themselves.
export function fiscalError(error) {
	const data = error && error.response && error.response.data;
	if (data && typeof data === "object" && (data.message || data.error))
		return data.message || data.error;
	if (error && error.code === "ECONNABORTED")
		return "Фискалниот сервер не одговори навреме";
	if (error && !error.response) return "Фискалниот сервер не е достапен";
	return "Грешка од фискалниот сервер (" + error.response.status + ")";
}
